import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import SideBar from './SideBar-redux';

export default compose(
    withRouter
)(SideBar);
